import { isDefined } from "@omni/utils/helper.utils";
import { identity } from "lodash-es";

import { FaqCategory } from "../types/faqCategory.types";
import { FaqQuestion } from "../types/faqQuestion.types";
import { FaqSelection } from "../types/faqSelection.types";

export const pushSelection =
    (
        categoryByAliasMap: Map<string, FaqCategory>,
        questionByAliasMap: Map<string, FaqQuestion>
    ) =>
    (newSelection: FaqSelection) => {
        const pathSegments = document.location.pathname
            .split("/")
            .filter(identity);

        const pathSuffix = document.location.search + document.location.hash;

        // Array index (negative / count from end) representing the index(es) of segments to omit
        // When constructing the new path, replace the category and question segment
        // -2 - Category and question in path (replace)
        // -1 - Category in path (replace + append)
        // undefined - No category or question in path (append)
        const faqUrlSegmentsIndex =
            pathSegments
                .slice(-2)
                .map(
                    (pathSegment) =>
                        categoryByAliasMap.has(pathSegment) ||
                        questionByAliasMap.has(pathSegment)
                )
                .reduce((sum, curr) => sum - (curr ? 1 : 0), 0) || undefined;

        const newPath = [
            ...pathSegments.slice(0, faqUrlSegmentsIndex),
            newSelection.category.alias,
            newSelection.question?.alias
        ]
            .filter(identity)
            .join("/");

        window.history.pushState({}, "", `/${newPath}${pathSuffix}`);
    };

export const readSelection =
    (
        categoryByAliasMap: Map<string, FaqCategory>,
        questionByAliasMap: Map<string, FaqQuestion>
    ) =>
    (): FaqSelection | undefined => {
        const segments = document.location.pathname
            .split("/")
            .filter(identity)
            .slice(-2);

        const category = segments
            .map((segment) => categoryByAliasMap.get(segment))
            .filter(isDefined)
            .at(0);
        const question = segments
            .map((segment) => questionByAliasMap.get(segment))
            .filter(isDefined)
            .at(0);

        if (!isDefined(category)) return;

        return {
            category: category,
            question: question
        };
    };
